<sb-sidenav class="left-panel">
    <app-left-menu></app-left-menu>
</sb-sidenav>

<div class="sidenav-content" [class.ps-0]="!sideNavigationService.isLeftMenuOpen">
    <app-top-menu></app-top-menu>

    <div class="content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>
